/**
 * @typedef {object} SeasonLeadersState
 * @property {object} data
 */

/**
 * @typedef {object} SeasonLeadersActions
 * @property {string} type
 * @property {any} payload
 */